import { HTTP } from './helpers/http.js'

export default {
  getById(organizationId, revId) {
    const url = `/api/v1/organizations/${organizationId}/problem-solving/${revId}`
    return HTTP.get(url)
  },
}
